import { Badge, Box, Button, useTheme } from '@mui/material';
import { FC, useContext, useMemo } from 'react';
import { PANEL } from '@/contexts/UIState/types';
import { COMMON_STRING, DICTIONARY } from '@/constants/dictionary';
import { UIStateContext } from '@/contexts/UIState/context';
import { LightDivider } from '@/components/common/LightDivider';
import { ScoringContext } from '@/contexts/scoring/context';
import { MarketsContext } from '@/contexts/markets/context';
import { KeyboardButton } from '@/components/common/KeyboardButton';
import { ArchiveGuard } from '../common/ArchiveGuard';

export const MarketButton: FC = () => {
  const {
    state: { fixtureId },
  } = useContext(ScoringContext);
  const { setOpenedPanel } = useContext(UIStateContext);
  const { marketsPerAction, marketsPerActionList } = useContext(MarketsContext);
  const theme = useTheme();

  const closedMarketsCount = useMemo(
    () =>
      !marketsPerAction
        ? 0
        : Object.values(marketsPerAction).filter(
            (marketPerAction) => !marketPerAction.isMarketOpen,
          ).length,
    [marketsPerAction],
  );

  if (!fixtureId || !marketsPerAction || !marketsPerActionList) return null;

  return (
    <>
      <Box pr={1.5}>
        <Badge badgeContent={closedMarketsCount} color='error'>
          <ArchiveGuard
            activeTooltip={
              <>
                {DICTIONARY.COMMON.DATA_REVIEW}
                <KeyboardButton theKey='m' />
              </>
            }
          >
            <Button
              sx={{
                color: 'inherit',
                backgroundColor: theme.palette.primary.light,
                '&.Mui-disabled': {
                  backgroundColor: theme.palette.archived,
                  color: theme.palette.secondary.contrastText,
                },
              }}
              variant='contained'
              size='small'
              onClick={() => setOpenedPanel(PANEL.DATA_REVIEW)}
            >
              {COMMON_STRING.DATA_REVIEW}
            </Button>
          </ArchiveGuard>
        </Badge>
      </Box>

      <LightDivider orientation='vertical' flexItem />
    </>
  );
};
